export default class Country {
  public code: string;
  public name: string;

  constructor(code: string, name: string) {
    this.code = code;
    this.name = name;
  }
}


// WEBPACK FOOTER //
// ./src/modules/shared/models/Country.ts